import type { Step } from "react-joyride";

export const projectListTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຫນ້າການຈັດການໂຄງການ! ໂຄງການ (Project) ແມ່ນເຄື່ອງມືທີ່ຊ່ວຍຈັດການໂຄງການ ວຽກຍ່ອຍ ແລະ ຄວາມສຽງ ເພື່ອຕິດຕາມຄວາມຄືບໜ້າ. ທ່ານຈະໄດ້ຮຽນຮູ້ວິທີໃຊ້ງານຫນ້ານີ້ໃນບົດສອນສັ້ນໆນີ້.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="project-toolbar"]',
    content:
      "ນີ້ແມ່ນປຸ່ມເພີ່ມໂຄງການໃໝ່. ກົດປຸ່ມນີ້ເພື່ອເລີ່ມສ້າງໂຄງການທີ່ທ່ານຕ້ອງການ ກຳນົດຊື່ ວັນທີ ຜູ້ຮັບຜິດຊອບ ແລະ ຂັ້ນຕອນໂຄງການ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="project-filter"]',
    content:
      "ນີ້ແມ່ນພາກການກອງຂໍ້ມູນ. ທ່ານສາມາດຄົ້ນຫາໂຄງການຕາມຊື່, ສະຖານະ (ກຳລັງດຳເນີນການ/ສຳເລັດ/ຢຸດ), ຜູ້ຮັບຜິດຊອບ ຫຼື ວັນເລີ່ມ/ວັນສິ້ນສຸດ. ກົດ 'ລ້າງ' ເພື່ອລຶບການກອງທັງໝົດ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="project-table"]',
    content:
      "ນີ້ແມ່ນຕາຕະລາງສະແດງໂຄງການທັງໝົດ. ທ່ານສາມາດກົດຊື່ໂຄງການເພື່ອເບິ່ງລາຍລະອຽດ, ຫຼືໃຊ້ປຸ່ມການກະທຳ (⋮) ເພື່ອແກ້ໄຂ ຫຼື ລຶບໂຄງການ.",
    placement: "top",
  },
];
